/**
 * @generated SignedSource<<bb14a76de0cc0cef2dd03d8605e67e6b>>
 * @relayHash 9c224d65096c7ebcd032758c59449512
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e7ac7454e0f9398d0a31668be1eae7eed03b3e523c09470aee832d8ee14b47d4

import type { ConcreteRequest } from 'relay-runtime';
export type OnboardingStateInput = {
  key: string;
  value: string;
};
export type SetOnboardingStateMutation$variables = {
  states: ReadonlyArray<OnboardingStateInput>;
};
export type SetOnboardingStateMutation$data = {
  readonly setOnboardingState: ReadonlyArray<{
    readonly key: string;
    readonly value: string | null;
  }> | null;
};
export type SetOnboardingStateMutation = {
  response: SetOnboardingStateMutation$data;
  variables: SetOnboardingStateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "states"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "states",
        "variableName": "states"
      }
    ],
    "concreteType": "OnboardingState",
    "kind": "LinkedField",
    "name": "setOnboardingState",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "kind": "ScalarField",
        "name": "value"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SetOnboardingStateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SetOnboardingStateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9c224d65096c7ebcd032758c59449512",
    "id": "e7ac7454e0f9398d0a31668be1eae7eed03b3e523c09470aee832d8ee14b47d4",
    "metadata": {},
    "name": "SetOnboardingStateMutation",
    "operationKind": "mutation",
    "text": "mutation SetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key,value}}"
  }
};
})();

(node as any).hash = "69ff9399f6f631fded012361d38c9b30";

export default node;
